import URI from 'urijs'
import { ensureArray } from './helpers'

const truncateLink = (link) => (~!!link.indexOf('?') && link.substring(0, link.indexOf('?'))) || link

export const isProviderLink = (href) => ~href.indexOf('.amazon.') || ~href.indexOf('.amzn.') || false
const toLowerKeys = (obj) => ({ ...Object.keys(obj).reduce((acc, key) => ({ ...acc, [camelToSnakeCase(key)]: obj[key] }), {}) })
const camelToSnakeCase = (text) => {
    return (text + '')
        .replace(/(.)([A-Z][a-z]+)/, '$1_$2')
        .replace(/([a-z0-9])([A-Z])/, '$1_$2')
        .toLowerCase()
}
const provider = {
    amazon: {
        AvailabilityArray: [
            { id: 0, inherited_type: 'Now' },
            { id: 10, inherited_type: 'Backorderable' },
            { id: 20, inherited_type: 'Preorderable' },
        ],
        transformAmazonImageObject: (ai) => {
            return { ...Object.keys(ai).reduce((acc, key) => ({ ...acc, [key.toLowerCase()]: ai[key] }), {}) }
        },
        transformAmazonImage: (ai) => {
            return {
                ...provider.amazon.transformAmazonImageObject(ai.Medium),
                small: provider.amazon.transformAmazonImageObject(ai.Small),
                medium: provider.amazon.transformAmazonImageObject(ai.Medium),
                large: provider.amazon.transformAmazonImageObject(ai.Large),
            }
        },
        transformAmazonNode: (an) => {
            return {
                is_root: an.IsRoot,
                id: an.Id,
                label: an.ContextFreeName || an.DisplayName,
                sales_rank: an.SalesRank || undefined,
                ancestor: (an.Ancestor && provider.amazon.transformAmazonNode(an.Ancestor)) || undefined,
                inherited: an,
            }
        },
        transformAmazonAvailability: (aa) => {
            // Now | Backorderable | Preorderable
            return { available: provider.amazon.isAmazonAvailable(aa), id: provider.amazon.AvailabilityArray.find((a) => a.inhereted_type === aa.type)?.id }
        },
        isAmazonAvailable: (aa) => aa.Type === 'Now',
        transformAmazonOffer: (ao) => {
            return {
                available: provider.amazon.isAmazonAvailable(ao.Availability),
                availability: provider.amazon.transformAmazonAvailability(ao.Availability),
                id: ao.Id,
                price: toLowerKeys(ao.Price),
                inherited: ao,
            }
        },
        // transformAmazonProduct: (ap) => {
        //     const offer_array = ap.Offers?.Listings?.map(provider.amazon.transformAmazonOffer).sort((a, b) => a.available&&!b.available?-1:(!a.available>b.available&&1||0))
        //     const offer = ap.Offers?.Summaries?.find((o) => o.Condition?.Value==='New')?.LowestPrice
        //     return {
        //         inherited: ap,
        //         ASIN: ap.ASIN,
        //         id: ap.ASIN,
        //         label: ap.ItemInfo?.Title?.DisplayValue,
        //         detail_page_url: ap.DetailPageURL,
        //         image: ap.Images?.Primary&&transformAmazonImage(ap.Images?.Primary)||undefined,
        //         image_array: [ap.Images?.Primary&&transformAmazonImage(ap.Images?.Primary), ...(ap.Images?.Variants&&(ap.Images?.Variants.map(provider.amazon.transformAmazonImage))||[])].filter(Boolean),
        //         sales_rank: ap.BrowseNodeInfo?.BrowseNodes?.reduce((acc, item) => acc>item.SalesRank?item.SalesRank:acc, Infinity)||undefined,
        //         node_array: ap.BrowseNodeInfo?.BrowseNodes?.map(provider.amazon.transformAmazonNode)||[],
        //         offer_array: offer_array,
        //         offer: offer ? toLowerKeys(offer) : undefined,
        //         available: offer_array.reduce((acc, a) => acc||a.available, false),
        //         availability: offer_array?.[0],
        //     }
        // },
        getNormalizedProduct: (item) => {
            if (!item || !item.DetailPageURL) {
                console.error('No item passed to getNormalizedProduct!')
                return {}
            }
            // const image_set = provider.amazon.getGlobalImageSet(item)
            // const image = (image_set && image_set[0]) || {}
            // console.log({ item }, { image_set }, { image })
            console.log({ item }, item.DetailPageURL, item.detail_page_url)
            const href = URI(item.DetailPageURL)
            href.removeSearch('SubscriptionId')
            href.removeSearch('tag')
            const sanitizedUrl = href.toString()
            // const product = {
            //     BrowseNodes: item.BrowseNodes || undefined,
            //     label: item.ItemAttributes.Title,
            //     image_url: (image.LargeImage && image.LargeImage.URL) || undefined,
            //     image_url_array:
            //         [
            //             ...new Set(
            //                 provider.amazon
            //                     .getGlobalImageSet(item)
            //                     .map(image => (image.LargeImage && image.LargeImage.URL) || null)
            //                     .filter(Boolean)
            //             )
            //         ] || undefined,
            //     href: item.DetailPageURL,
            //     external_id: item.ASIN,
            //     provider: 'amazon',
            //     query: item.current_query_object || undefined,
            //     query_id: item.unique_query_id || undefined,
            //     detailed_page: truncateLink(item.DetailPageURL),
            //     price: provider.amazon.getPrice(item),
            //     available: provider.amazon.getAvailable(item),
            //     sanitizedUrl
            // }
            // return product

            const offer_array = item.Offers?.Listings?.map(provider.amazon.transformAmazonOffer).sort((a, b) =>
                a.available && !b.available ? -1 : (!a.available > b.available && 1) || 0
            )
            const offer = item.Offers?.Summaries?.find((o) => o.Condition?.Value === 'New')?.LowestPrice
            const image = (item.Images?.Primary && provider.amazon.transformAmazonImage(item.Images?.Primary)) || undefined
            const image_array = [
                item.Images?.Primary && provider.amazon.transformAmazonImage(item.Images?.Primary),
                ...((item.Images?.Variants && item.Images?.Variants.map(provider.amazon.transformAmazonImage)) || []),
            ].filter(Boolean)
            return {
                inherited: item,
                ASIN: item.ASIN,
                id: item.ASIN,
                label: item.ItemInfo?.Title?.DisplayValue,
                detail_page_url: item.DetailPageURL,
                detailed_page: truncateLink(item.DetailPageURL),
                image: image,
                image_url: image?.url,
                image_array,
                image_url_array: image_array.map((image) => image.url),
                href: item.DetailPageURL,
                external_id: item.ASIN,
                provider: 'amazon',
                query: item.current_query_object || undefined,
                query_id: item.unique_query_id || undefined,
                sales_rank: item.BrowseNodeInfo?.BrowseNodes?.reduce((acc, item) => (acc > item.SalesRank ? item.SalesRank : acc), Infinity) || undefined,
                node_array: item.BrowseNodeInfo?.BrowseNodes?.map(provider.amazon.transformAmazonNode) || [],
                offer_array: offer_array,
                offer: offer ? toLowerKeys(offer) : undefined,
                available: (offer_array || []).reduce((acc, a) => acc || a.available, false),
                availability: offer_array?.[0],
                price: offer?.display_amount,
                sanitizedUrl,
            }
        },
    },
}

export default provider

export const endpoint_array = [
    { label: 'AU', value: 'AU' },
    { label: 'BR', value: 'BR' },
    { label: 'CA', value: 'CA' },
    { label: 'CN', value: 'CN' },
    { label: 'DE', value: 'DE' },
    { label: 'ES', value: 'ES' },
    { label: 'FR', value: 'FR', default: true },
    { label: 'IN', value: 'IN' },
    { label: 'IT', value: 'IT' },
    { label: 'JP', value: 'JP' },
    { label: 'MX', value: 'MX' },
    { label: 'TR', value: 'TR' },
    { label: 'UK', value: 'UK' },
    { label: 'US', value: 'US' },
]

export const locale_array = [
    { locale: 'fr_FR', label: 'FR' },
    { locale: 'es_ES', label: 'ES' },
    { locale: 'it_IT', label: 'IT' },
    { locale: 'de_DE', label: 'DE' },
    { locale: 'en_UK', label: 'UK' },
    { locale: 'en_US', label: 'US' },
]

export const searchIndex_array = [
    { label: 'All' },
    { label: 'Apparel' },
    { label: 'Appliances' },
    { label: 'Baby' },
    { label: 'Beauty' },
    { label: 'Blended' },
    { label: 'Books' },
    { label: 'Classical' },
    { label: 'DVD' },
    { label: 'Electronics' },
    { label: 'ForeignBooks' },
    { label: 'GiftCards' },
    { label: 'HealthPersonalCare' },
    { label: 'HomeImprovement' },
    { label: 'Jewelry' },
    { label: 'KindleStore' },
    { label: 'Kitchen' },
    { label: 'LawnAndGarden' },
    { label: 'Lighting' },
    { label: 'Luggage' },
    { label: 'MP3Downloads' },
    { label: 'MobileApps' },
    { label: 'Music' },
    { label: 'MusicalInstruments' },
    { label: 'OfficeProducts' },
    { label: 'PCHardware' },
    { label: 'PetSupplies' },
    { label: 'Shoes' },
    { label: 'Software' },
    { label: 'SportingGoods' },
    { label: 'Toys' },
    { label: 'VideoGames' },
    { label: 'Watches' },
]

export const rates = [
    {
        rate: 3,
        BrowseNodes: [
            { label: 'Informatique', id: '340858031' },
            { label: 'Produits électroniques', id: '339998031' },
            { label: 'Jeux vidéo', id: '530490' },
            { label: 'Photo et Caméscopes', id: '13910691' },
            { label: 'Chèques-cadeaux', id: '2524127031' },
            { label: 'TV', id: '14059871' },
            { label: 'Home Cinéma et Vidéo', id: '13910681' },
            { label: 'Smartphones & Téléphones portables', id: '14060661' },
            { label: 'Gros électroménager', id: '908826031' },
            { label: 'Kindle (tous appareils)', id: '672108031' },
            { label: 'Accessoires Kindle', id: '838317031' },
        ],
    },

    {
        rate: 5,
        BrowseNodes: [
            { label: "Appareils liés à l'hygiène", id: '' },
            { label: "Santé et produits d'hygiène", id: '197861031' },
            { label: 'Produits pour le bureau', id: '192419031' },
            { label: 'Bébé', id: '206617031' },
            { label: 'Animalerie', id: '1571268031' },
            { label: 'Épicerie', id: '3635788031' },
            { label: 'Instruments de musique', id: '340861031' },
            { label: 'Bière', id: '6356831031' },
            { label: 'Vin & Spiritueux', id: '6356830031' },
            { label: 'Logiciels', id: '530488' },
            { label: 'Jeux vidéo à télécharger ', id: '' },
            { label: 'Logiciels à télécharger', id: '' },
            { label: 'Commerce', id: '5866109031' },
            { label: 'Industrie et science', id: '5866109031' },
        ],
    },

    {
        rate: 7,
        BrowseNodes: [
            { label: 'Cuisine', id: '7424202031' },
            { label: 'Bricolage', id: '590748031' },
            { label: 'Maison', id: '57004031' },
            { label: 'Mobilier', id: '194641031' },
            { label: 'eBooks Kindle', id: '695398031' },
            { label: 'DVD& Bluray', id: '405322' },
            { label: 'Jardin', id: '3557027031' },
            { label: 'Livres', id: '301061' },
            { label: 'Auto & Moto', id: '1571265031' },
            { label: 'Musique', id: '301062' },
        ],
    },
    {
        rate: 6,
        BrowseNodes: [
            { label: 'Sports & Loisirs', id: '325614031' },
            { label: 'Jeux et jouets', id: '322086011' },
        ],
    },

    {
        rate: 10,
        BrowseNodes: [
            { label: 'Handmade', id: '9699368031' },
            { label: 'Beauté', id: '197858031' },
        ],
    },

    {
        rate: 11,
        BrowseNodes: [
            { label: 'Vêtement', id: '340855031' },
            { label: 'Chaussures', id: '1765042031' },
            { label: 'Bijoux', id: '193710031' },
            { label: 'Montres', id: '60649031' },
            { label: 'Bagagerie', id: '2454145031' },
            { label: 'Amazon Mode Private Label Femme', id: '' },
            { label: 'Homme & Enfant', id: '' },

            { label: 'Chaussures et Sacs', id: '215934031' },
        ],
    },
    // chaussures et sacs : 215934031
    // sacs : 1765335031
    // femme : 1765336031
    {
        rate: 3,
        BrowseNodes: [],
        default: true,
    },
]
